export { default } from './SWSectionTabs';
